import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Search } from 'UI';

import {
  MainContainer,
  SearchContainer,
} from './style';

interface ResourceExtraProps {
  onSearch(content: string): void
  onAddClick(): void
}

const ResourceExtra = ({
  onSearch,
  onAddClick,
}: ResourceExtraProps): JSX.Element => (
  <MainContainer>
    {/* TODO: add search input */}
    <SearchContainer>
      <Search placeholder="Buscar item" onSearch={onSearch} allowClear />
    </SearchContainer>
    <Button
      icon={<PlusOutlined size={14} />}
      onClick={onAddClick}
    >
      Novo
    </Button>
  </MainContainer>
);

export default ResourceExtra;
